import { render, staticRenderFns } from "./Telesale.vue?vue&type=template&id=0526c7b4&"
import script from "./Telesale.vue?vue&type=script&lang=ts&"
export * from "./Telesale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports